'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$4(outer) {
  this.bVv = null;
  this.bVt = null;
  this.bVu = false;
  this.bVr = null;
  this.bVs = false;
  this.bVw = false;
  this.bVx = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bVv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$4 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$4 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$4;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$4() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$4 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$4 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bVv;
});
$p.t = (function() {
  if ((!this.bVu)) {
    this.bVt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deadlineDays", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sequential", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bVu = true;
  }
  return this.bVt;
});
$p.ag = (function() {
  if ((!this.bVs)) {
    this.bVr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().rw, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bVs = true;
  }
  return this.bVr;
});
$p.v = (function() {
  if ((!this.bVx)) {
    this.bVw = false;
    this.bVx = true;
  }
  return this.bVw;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$4, "presto.pages.envelopes.EnvelopesView$$anon$4", ({
  WJ: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$4 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$4 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$4.js.map
